import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

import IconBlack from '/shared/images/icons/icon-warning-black-full.svg';

interface Props {
  isFieldError?: boolean;
}

function isFieldErrorStyle({ isFieldError }: Props) {
  if (isFieldError) {
    return css`
      margin-top: 1rem;

      &::after {
        content: '';
        position: absolute;
        top: -0.4rem;
        left: 1.5rem;
        width: 0.8rem;
        height: 0.8rem;
        background: ${Colours.whiteDark1};
        transform: rotate(45deg);
      }
    `;
  }
}

export default styled.div<Props>`
  padding: 1.5rem 2rem 1.5rem 1rem;
  border-left: 4px solid ${Colours.redLight5};
  background: ${Colours.whiteDark1};
  display: flex;
  margin-bottom: 0.5rem;
  width: 100%;

  &::before {
    content: '';
    background: url('${IconBlack}') center center no-repeat;
    height: 1.4rem;
    width: 1.6rem;
    margin-right: 1rem;
  }

  div {
    flex: 1;
    line-height: 1.6;
    font-size: 0.9333rem;
    font-weight: normal;
    white-space: normal;
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 500;
    /* padding-top: 0.2rem; */
  }

  ul {
    padding: 0 0 0 1rem;
    margin: 0;

    li {
      padding-left: 0.5rem;

      span {
        strong {
          font-family: monospace;
        }
      }
    }
  }
  ${isFieldErrorStyle}
`;
